module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ("ui " + _vm.customClass + " dropdown"),
    attrs: {
      "id": _vm.dropdownId
    }
  }, [_c('div', {
    staticClass: "text"
  }, [(_vm.hasIcons) ? _c('i', {
    class: ((_vm.value[_vm.iconProperty]) + " icon")
  }) : _vm._e(), _vm._v("\n        " + _vm._s(_vm.value.text) + "\n    ")]), _vm._v(" "), _c('i', {
    staticClass: "dropdown icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, _vm._l((_vm.options), function(option) {
    return _c('div', {
      key: option.value,
      staticClass: "item",
      attrs: {
        "data-value": option.value
      }
    }, [(_vm.hasIcons) ? _c('i', {
      class: ((option[_vm.iconProperty]) + " icon")
    }) : _vm._e(), _vm._v("\n            " + _vm._s(option.text) + "\n        ")])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7daa9577"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/semvue/components/Dropdown.vue
// module id = 154
// module chunks = 1